export const iconFontAwesomeHouseholdKitchenSet = (
	<i className="fa-solid fa-kitchen-set"></i>
);
